import { Box, Chip } from "@mui/material";
import { getCoachLanguagesOptions, getLabel } from "../../../components/Forms";
import { LinkedInProfileMaybe } from "../../../components/LinkedInProfileMaybe";
import { H2, P } from "../../../components/Typography";
import { formatName } from "../../Coaches/coach.utils";
import { useCertificateOptions } from "../options";
import { useFieldsDict } from "../useFieldsDict";

// TODO: CoachInfo?
export const CoachInfoFields = ({
  msg,
  i18n,
  coach: {
    firstName,
    lastName,
    certificate,
    experienceSince,
    languages,
    bio,
    fields,
    linkedinProfile,
  } = {},
}) => {
  const certificatesOptions = useCertificateOptions();
  const { fieldsOptions } = useFieldsDict();

  return (
    <>
      <H2 mt={3}>{formatName({ firstName, lastName })}</H2>
      {certificate && (
        <P mt={1}>
          {msg("settings.profile.field.level")}
          {": "}
          {getLabel(certificatesOptions)(certificate)}
        </P>
      )}
      <P mt={1}>
        {msg("settings.profile.field.experience")}
        {": "}
        {experienceSince
          ? `${i18n.formatDistanceToNowLocal(experienceSince)}`
          : ""}
      </P>
      <P mt={1}>
        {msg("settings.profile.field.languages")}
        {": "}
        {[]
          .concat(languages)
          .map(getLabel(getCoachLanguagesOptions()))
          .join(", ")}
      </P>
      <P
        sx={{
          whiteSpace: "normal",
          my: 3,
        }}
        color="black"
      >
        {bio}
      </P>
      <Box display="flex" gap={1}>
        {[]
          .concat(fields)
          .map(getLabel(fieldsOptions))
          .map((label, i) => (
            <Chip
              key={label || i}
              sx={{ borderRadius: "6px", bgcolor: "#F9F8FF" }}
              label={label}
            />
          ))}
      </Box>
      <LinkedInProfileMaybe href={linkedinProfile} />
    </>
  );
};
